<template>
  <ModalPopup :is-visible="isVisible" title="이용약관" size="lg" class="modal-policy" @close="handleClose">
    <div class="policy-content">
      <strong>제1조 목적</strong>
      <p>
        본 약관은 "빌레터폰지킴" (이하 "서비스")을 제공하는 "주식회사 오션블루"(이하 "회사"라고 합니다)와 "가입자"(이하
        "가입자")의 이용에 있어 "가입자"와 "회사" 간의 권리, 의무 및 책임 사항, "서비스" 이용 조건 및 절차 등 기본적인
        사항을 규정함을 목적으로 합니다.
      </p>

      <strong>제2조 용어의 정의</strong>
      <ol>
        <li>
          ① 본 약관에서 사용하는 용어의 정의는 다음과 같습니다.

          <ol>
            <li>1. "이용계약"이라 함은 "서비스" 이용을 위해 "회사"와 "가입자" 사이에 체결하는 계약을 말합니다.</li>
            <li>2. "이용요금"이라 함은 이용계약에 따라 "가입자"가 "회사"에게 지급하여야 할 금원을 말합니다.</li>
            <li>
              3. "서비스"라 함은 "가입자"가 휴대폰 분실 신고 시, SKT(이하 "통신사")으로부터 분실 신고 상태를 "회사"가
              조회 하여, "가입자"가 지정한 "비상 연락처"로 관련 사실을 통지하고 금융회사 및 전자금융 사업자의
              이상금융거래탐지시스템(FDS - Fraud Detection System 및 모니터링 시스템) 등과의 연계를 통해 금융 피해 및
              보이스 피싱 등의 2차 피해 예방을 지원하는 제반 서비스를 말합니다.
            </li>
            <li>
              4. "가입자"라 함은 "회사"의 "서비스"에 접속하여 본 약관 등에 따라 "회사"와 이용 계약을 체결하고 "회사"가
              제공하는 "서비스"를 이용하는 고객을 의미합니다.
            </li>
            <li>
              5. "비상 연락처"라 함은 분실 신고 시 피해 예방 관련 알림을 수신하도록 "가입자"가 직접 등록한 제3자의
              연락처를 말합니다.
            </li>
            <li>
              6. "제휴회사"라 함은 "회사"가 "가입자"에게 이용계약에 따른 "서비스"를 제공함에 있어서 "가입자"에게 최상의
              서비스 품질 제공하고 금융회사 및 전자금융 사업자의 이상금융거래탐지시스템 과 연계하여 금융 피해를 예방하기
              위해 "회사"와 업무 제휴계약을 체결한 한 제휴처를 말합니다.
            </li>
            <li>
              7. "월정액"이란 "서비스"의 이용요금을 "서비스" 해지 시까지 매월 자동으로 청구, 결제되는 방식을 말합니다.
            </li>
            <li>8. "휴대폰정보"란 "가입자"의 이동통신사 휴대폰번호 가입한 정보를 말합니다.</li>
            <li>
              9. "금융 보안 가이드"라 함은 "회사"가 "서비스" 내에서 제공하는 최신 금융사기 사례, 예방 수칙 등 정보성
              콘텐츠를 말합니다.
            </li>
            <li>
              10. "휴대폰 분실 금융 피해 보험"이라 함은 "회사"가 제휴 보험사와 연계하여 "가입자"에게 별도로 제공하는
              휴대폰 분실에 따른 보험 상품을 말합니다.
            </li>
            <li>
              11. "쿠폰"이라 함은 "회사"가 프로모션 등의 목적으로 "가입자"에게 제공하는 할인 또는 증정 혜택을 말합니다.
            </li>
          </ol>
        </li>
        <li class="mt-4">
          ② 본 약관에서 사용하는 용어의 정의는 제1항에서 정하는 것을 제외하고는 관계 법령 및 서비스 안내에서 정하는 바에
          의합니다.
        </li>
      </ol>

      <strong>제3조 "서비스"의 이용조건 및 "가입자"의 자격 상실 등</strong>
      <ol>
        <li>
          ① "서비스" 이용요금과 청구방법 등은 아래와 같습니다.
          <ol>
            <li>1. 이용요금: 월정액 3,300원(부가세 포함), 중도해지 시 일할 계산하여 과금</li>
            <li>
              2. 결제방식: 매월 1회의 요금이 청구되며, 이동통신사 요금고지서에 표시되어 휴대전화 요금에 합산 청구됩니다.
            </li>
            <li>3. 환불 및 결제: "회사"는 관계 법령이 정한 바에 따라 환불 및 결제합니다.</li>
          </ol>
        </li>
        <li>
          ② "서비스" 이용요금은 "회사"의 사정에 따라 변경될 수 있으며, 이 경우 변경된 내용은 어플리케이션 또는 기타의
          방법으로 사전에 안내하여 드립니다.
        </li>
        <li>
          ③ "가입자"가 다음 각호의 사유에 해당하는 경우 서비스의 이용을 제한할 수 있습니다.
          <ol>
            <li>1. "서비스" 게시판 등 화면에 음란물을 게재하거나 링크 시키는 경우</li>
            <li>2. "서비스" 게시판 등 화면에 타인의 명예를 손상시키거나 불이익을 주는 행위를 하는 경우</li>
            <li>3. 기타 해킹, 컴퓨터 바이러스 유포 등의 방법으로 "서비스"의 운영을 고의적으로 방해한 경우</li>
            <li>
              4. 본 서비스 이용약관의 당일 가입/해지의 무과금 조건을 악용하여 반복적으로 가입/해지를 진행하는 경우
            </li>
          </ol>
        </li>
        <li>
          ④ 분실 금융 피해 보험은 본 서비스 가입 익일부터 서비스 해지일까지 적용됩니다.
          <ol>
            <li>
              1. 회사가 보험계약을 체결하며, 보험 계약과 관련된 모든 권리 의무는 회사가 행사합니다. 보험료는 전액 회사가
              부담하며, 보험금 지급 사유 발생 시 서비스 이용자 1인 1사고당 보험한도액은 300만원입니다. 보험금 지급 시
              자기부담금(60만원)이 발생하며, 증권상 최대보상한도액 초과 시 보험금이 지급되지 않을 수 있습니다.
            </li>
            <li>
              2. 분실 금융 피해 보상을 위한 기업비용보상보험은 이용요금과 무관한 보험이며, 보험한도액 및 자기부담금은
              사고율에 따라 증감이 될 수 있고 보험계약이 철회될 수 있습니다.
            </li>
          </ol>
        </li>
      </ol>

      <strong>제4조 이용신청</strong>
      <p>
        "가입자"가 "서비스" 내에 게시되는 약관의 내용확인 및 가입절차를 거쳐 동의 버튼을 누르면 "서비스" 이용을 신청한
        것으로 간주됩니다.
      </p>

      <strong>제5조 "서비스"의 내용</strong>
      <ol>
        <li>
          ① 휴대폰 분실 신고에 따른 2차 피해 방지 알림: "회사"가 "통신사"로부터 조회한 "가입자"의 휴 대폰 회선 상태(분실
          신고)를 "서비스" 내에 표시하고 "가입자"가 지정한 "비상 연락처"로 2차 피해 예방을 위한 문자알림을 발송하는
          서비스
        </li>
        <li>② 금융 보안 가이드 제공: "가입자"의 금융사기 피해 예방을 위한 정보성 콘텐츠 제공</li>
        <li>
          ③ 분실 금융 피해 보험 혜택 안내 및 신청 연계: "회사"가 제휴한 보험사의 휴대폰 분실 금융 해 보험 상품에 대한
          안내 및 신청 접수
        </li>
        <li>④ 쿠폰 발급 및 이용: "가입자"가 "서비스"에서 쿠폰 조회 및 사용할 수 있게 해주는 서비스</li>
        <li>
          ⑤ 전기통신금융사기 예방: 금융회사 및 전자금융 사업자 FDS(이상금융거래탐지시스템) 연동으로 보이스피싱을 비롯한
          전기통신금융사기 예방
        </li>
      </ol>

      <strong>제6조 이용요금 등의 환불</strong>
      <ol>
        <li>
          ① "가입자"는 다음 각 호 중 어느 하나에 해당하는 사유가 발생한 경우 "회사"에 이용요금의 환불을 요청할 수 있고,
          "회사"는 "가입자"로부터 환불 요청을 받은 날로부터 15일 이내에 환불 사유에 해당하는지 여부를 검토한 후
          "가입자"에게 환불 여부를 통보하여야 하며, 환불 사유에 해당하는 경우에는 환불 여부에 대한 통보를 한 날로부터
          7일 이내에 환불을 하여야 합니다.
          <ol>
            <li>1. "가입자"의 의사에 의해 중도해지를 원하는 경우</li>
            <li>2."회사"의 귀책사유로 "회사"가 "서비스"를 제공하지 못한 경우</li>
          </ol>
        </li>
        <li>
          ② "가입자"는 oceanbleu@oceanbleu.co.kr로 이메일을 발송하거나 1522-7607의 유선전화를 통한 방법으로 이용계약의
          해지를 요청할 수 있고, 위 해지의 의사표시가 "회사"에 도달한 날로부터 7일 이후에 이용계약은 해지된 것으로
          봅니다.
        </li>
        <li>
          ③ "회사"는 아래 각 호의 금원을 공제한 나머지 금원을 반환합니다.
          <ol>
            <li>1. 가입기간(유료 "서비스" 기간만을 의미합니다.)으로 일할 계산한 금액을 공제합니다</li>
          </ol>
        </li>
      </ol>

      <strong>제7조 약관의 효력 및 변경 </strong>
      <ol>
        <li>① 본 약관은 "서비스"를 이용하고자 하는 모든 "가입자"에 대하여 그 효력이 발생합니다.</li>
        <li>
          ② 본 약관의 내용은 "서비스" 내에 게시하거나 기타의 방법으로 "가입자"에게 공지하고, 이에 동의한 "가입자"가
          "서비스"를 사용함으로써 효력이 발생합니다.
        </li>
        <li>
          ③ "회사"는 필요한 경우 약관의 규제에 관한 법률, 정보통신망이용촉진 등에 관한 법률, 전자거래기본법, 전자서명법
          등 관련 법령에 위배되지 않는 범위 내에서 본 약관을 변경할 수 있고, "회사"가 본 약관을 변경할 경우에는 변경된
          약관의 효력 발생 일자 및 변경 사유를 "서비스" 제 2항과 같은 방법으로 적용 일자 7일 전부터 공지합니다.<br />
          "회사"는 약관이 변경된 경우 "가입자"에게 약관 변경 사실 및 내용을 통지하고, "가입자"가 변경된 약관 적용일까지
          약관 변경에 대한 거절의 의사표시를 명시적으로 하지 아니할 경우 변경된 약관에 동의한 것으로 간주하며, 변경된
          약관에 대한 정보를 알지 못하여 발생하는 "가입자"의 피해에 대하여 "회사"는 일체의 책임을 지지 않습니다.
        </li>
      </ol>

      <strong>제 1 조 (목적) </strong>
      <p>
        이 약관은 (주)이랜서(이하 "회사"라고 합니다.)가 인터넷 사이트(http://www.elancer.co.kr)를 통하여 제공하는
        e-marketplace서비스(이하 "서비스"라고 합니다.)의 이용과 관련하여 회사와 회원 간의 권리와 의무, 책임사항 및
        회원의 서비스 이용조건 및 절차, 기타 필요한 사항을 『전자 거래 기본법』 및 『정보 통신망 이용촉진 및 정보보호
        등에 관한 법률』 등 관련 법령에 의하여 규정함을 목적으로 합니다.
      </p>

      <!-- 나머지 약관 내용 -->
    </div>
    <template #footer>
      <div class="btn-group">
        <button class="btn btn-md btn-close" @click="handleClose">
          <span class="sr-only">닫기</span>
          <i class="ico ico-close-black-xl"></i>
        </button>
      </div>
    </template>
  </ModalPopup>
</template>

<script setup>
// Props 정의
const props = defineProps({
  isVisible: {
    type: Boolean,
    default: false,
  },
});

// Emits 정의
const emit = defineEmits(["close", "confirm"]);

// Methods
const handleConfirm = () => {
  emit("confirm");
};

const handleClose = () => {
  emit("close");
};
</script>
